import { Cancel } from '@mui/icons-material';
import {
  Box,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useGetDepartmentsByCompanyQuery } from '../../../redux/rtk/departments.services';
import { selectCompanyId } from '../../../redux/selectors/userDataSelectors';

const DepartmentsFilter = ({
  filtersSx,
  selectedFilters,
  setSelectedFilters,
}) => {
  const { t } = useTranslation('bulk');
  const userCompanyId = useSelector(selectCompanyId);
  const { data: departments } = useGetDepartmentsByCompanyQuery(userCompanyId, {
    skip: !userCompanyId,
  });

  const handleSelectedDepartments = e => {
    if (e.target.value.includes('all')) {
      setSelectedFilters(state => ({
        ...state,
        selectedDepartments: {
          departments,
          allSelected: true,
        },
      }));
    } else {
      setSelectedFilters(state => ({
        ...state,
        selectedDepartments: {
          departments: e.target.value,
          allSelected: false,
        },
      }));
    }
  };

  return departments ? (
    <FormControl size="small" sx={filtersSx}>
      <InputLabel>{t('department')}</InputLabel>
      <Select
        label={t('department')}
        value={selectedFilters.selectedDepartments.departments}
        onChange={handleSelectedDepartments}
        multiple
        SelectDisplayProps={{
          'data-testid': 'departmentsFilter',
        }}
        inputProps={{
          'data-testid': 'departmentsFilterInput',
        }}
        MenuProps={{
          sx: { maxHeight: '200px' },
        }}
        renderValue={() => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selectedFilters.selectedDepartments.allSelected ? (
              <Typography>{t('allOption')}</Typography>
            ) : (
              <Chip
                size="small"
                onDelete={() =>
                  setSelectedFilters(state => ({
                    ...state,
                    selectedDepartments: {
                      departments: [],
                      allSelected: false,
                    },
                  }))
                }
                deleteIcon={
                  <Cancel onMouseDown={event => event.stopPropagation()} />
                }
                label={`${
                  selectedFilters.selectedDepartments.departments.length
                } ${t('departmentsChip')}`}
              />
            )}
          </Box>
        )}
      >
        <MenuItem value="all">{t('allOption')}</MenuItem>
        <Divider />
        {departments.map((d, i) => (
          <MenuItem key={d + i} value={d}>
            {d}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : (
    <Skeleton variant="rounded" width={filtersSx.flexBasis} height={40} />
  );
};

export default DepartmentsFilter;
